/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { login, logout, loginAdmin } from '../utils/functions/authMethod';
import { useGetMerchantUserRoleQuery } from '../services/merchant';


function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // เพิ่มสถานะการล็อกอิน
  const { refetch } = useGetMerchantUserRoleQuery(undefined, {
    skip: !isLoggedIn, // ข้ามการ fetch ถ้ายังไม่ล็อกอิน
  });

  
  const handleSignin = async (email, password, taxId, typeTax) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    // console.log(email, password, taxId, typeTax);
    try {
      await login(email, password, taxId, typeTax);
      setIsLoggedIn(true);
    } catch (e) {
      console.error('Login Error:', e.response?.data || e.message);
      throw new Error(e);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      refetch(); // เรียก refetch หลังจากล็อกอินสำเร็จ
    }
  }, [isLoggedIn, refetch]);

  const handleAdminSignin = async (email, password) => {
    console.log('[AuthContext] กำลังเข้าสู่ระบบ');
    try {
      await loginAdmin(email, password);
      window.location.reload(); // รีเฟรชหน้าเว็บหลังล็อกอิน
    } catch (e) {
      throw new Error(e);
    }
  };
  

  const handleSignout = async () => {
    await logout();
    localStorage.removeItem('overdueDialogShown'); // รีเซ็ตค่า
    window.location.reload();
  };

  const handleAdminSignout = async () => {
    console.log('[AuthContext] กำลังลงชื่อออก');
    localStorage.removeItem('overdueDialogShown'); // รีเซ็ตค่า
    await logout();
    // window.location.reload();
  };

  return (
    <PassportAuth.Provider
      value={{
        handleSignin,
        handleAdminSignin,
        handleSignout,
        handleAdminSignout,
      }}
    >
      {children}
    </PassportAuth.Provider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AuthProvider;
export const PassportAuth = React.createContext();

